export interface Point2D {
    x: number;
    y: number;
}

export interface Rect {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

export function restrictNumber(min: number, value: number, max: number): number {
    return Math.min(Math.max(min, value), max);
}

export function deg2Rad(deg: number): number {
    return (Math.PI / 180) * deg;
}

export function rotatePoint(point: Point2D, centerPoint: Point2D, angle: number): Point2D {
    const rad = deg2Rad(angle),
        cos = Math.cos(rad),
        sin = Math.sin(rad);

    return {
        x: cos * (point.x - centerPoint.x) + sin * (point.y - centerPoint.y) + centerPoint.x,
        y: cos * (point.y - centerPoint.y) - sin * (point.x - centerPoint.x) + centerPoint.y
    };
}

export function rectContainsPoint(rect: Rect, point: Point2D): boolean {
    return point.x > rect.left && point.x < rect.right && point.y > rect.top && point.y < rect.bottom;
}
